module.exports = __webpack_public_path__ + "static/software-development-fb7fa90163285c88bbf90d0a9ca6f86d.png";